module.exports = {"330282002":"宗汉街道","330282003":"坎墩街道","330282004":"浒山街道","330282005":"白沙路街道","330282006":"古塘街道","330282104":"掌起镇","330282107":"观海卫镇","330282108":"附海镇","330282109":"桥头镇","330282110":"匡堰镇","330282111":"逍林镇","330282112":"新浦镇","330282113":"胜山镇","330282114":"横河镇","330282116":"崇寿镇","330282118":"庵东镇","330282120":"长河镇","330282121":"周巷镇","330282123":"龙山镇","330282402":"滨海经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330282.json
// module id = 1067
// module chunks = 0